var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_font_line"},[_c('span',{staticClass:"line",style:(("width: " + _vm.width + "px"))}),_c('p',{staticClass:"font"},[_vm._t("default")],2),_c('span',{staticClass:"line",style:(("width: " + _vm.width + "px"))})])}
var staticRenderFns = []

export { render, staticRenderFns }